"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconButtonVariants = exports.LinkIconButton = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("../../lib/utils");
const ButtonBase_1 = require("./ButtonBase");
const IconButton_1 = require("./IconButton");
Object.defineProperty(exports, "iconButtonVariants", { enumerable: true, get: function () { return IconButton_1.iconButtonVariants; } });
const LinkIconButton = react_1.default.forwardRef(({ className, color, size, variant, Icon, ...props }, ref) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { className: (0, utils_1.cn)((0, class_variance_authority_1.cx)((0, ButtonBase_1.buttonBaseVariants)({ color }), (0, IconButton_1.iconButtonVariants)({ size, variant, className }))), ref: ref, ...props },
        react_1.default.createElement(Icon, { className: "tw-h-4 tw-w-4" })));
});
exports.LinkIconButton = LinkIconButton;
LinkIconButton.displayName = "LinkIconButton";
